import { render, staticRenderFns } from "./ItemReturnTracking.vue?vue&type=template&id=dda34960&scoped=true&"
import script from "./ItemReturnTracking.vue?vue&type=script&lang=js&"
export * from "./ItemReturnTracking.vue?vue&type=script&lang=js&"
import style0 from "./ItemReturnTracking.vue?vue&type=style&index=0&id=dda34960&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda34960",
  null
  
)

export default component.exports